
import { getSites } from '@/utils/all_apis/admin';
import { fetchFileUrl } from '@/utils/all_apis/documentApi';

import { getMaterialReportData, getMaterialSummaryReportData } from '@/utils/all_apis/reports';
import { getProjectForms } from '@/utils/all_apis/formApi';


export const adminReportUrls:any = {
  'Annexure B': "/report?id=filter-test",
  // 'Inspection Report': "/report?id=inspection-report-steel",
  'Material Receipt': "/report?id=material-receipt",
  'Materials Summary Report': '/report?id=material-summary',
  'Materials Full Report': '/report?id=material',
  // 'Test': '/report?id=test',
  // 'Passed and Failed Submissions Report': '/report?id=content',
  // 'Geotagged Photos Report': '/report?id=content',
  // 'Components and Materials List Report': '/report?id=content',
  // 'Site Inspection Summary Report': '/report?id=content',
  // 'Quality Inspection Report': '/report?id=content',
};

export const materialReceiptTableOfContentsJson = [
  { 'S.no': '1', 'data':'studsferrule', 'component': "WeldingTable", 'header': "REGISTER", 'subheader':"STUDS / FERRULE + Sampling + Result", "off":"yes", "description":"STUDS / FERRULE + Sampling + Result", 'formNum':'FORM /06 REV 00 ', 'pageNo': '1' },
  { 'S.no': '2', 'data':'studsferrule1', 'component': "WeldingTable", 'header': "REGISTER", 'subheader':"FASTNERS + Sampling + Result", "off":"yes", "description":"FASTNERS + Sampling + Result ", 'formNum':'FORM /07 REV 00 ', 'pageNo': '2' },
  { 'S.no': '3', 'data':'studsferrule2', 'component': "WeldingTable", 'header': "REGISTER", 'subheader':"BOLTS / Nuts / washer + Sampling + Result", "off":"yes", "description":"BOLTS / Nuts / washer + Sampling + Result", 'formNum':'FORM /08 REV 00 ', 'pageNo': '3' },
  { 'S.no': '4', 'data':'studsferrule3', 'component': "WeldingTable", 'header': "REGISTER", 'subheader':"PAINTS + Sampling + Result", "off":"yes", "description":"PAINTS + Sampling + Result", 'formNum':'FORM /09 REV 00 ', 'pageNo': '4' },
]

export const tableOfContentsJson = [
  { 'S.no': '1', 'component': "CuttingBevellingTable", 'header': "INSPECTION REPORT", 'description': 'Visual and Dimension Inspection sheet for Cutting & Beveling (Form 11)', 'formNum':'Form 11', 'pageNo': '6' },
  { 'S.no': '2', 'component': "CuttingBevellingTable", 'header': "INSPECTION REPORT", 'description': 'Inspection After drilling operations on Plates (Form 12A)', 'formNum':'Form 12A', 'pageNo': '7' },
  { 'S.no': '3', 'component': "EmptyTable", 'header': "INSPECTION REPORT", 'description': 'Inspection After Splice Plate drilling - Alignment check between Splice Plate and Drilling Template (Jig & Fixtures) (Form 12B)', 'formNum':'Form 12B', 'pageNo': '8' },
  { 'S.no': '4', 'component': "EmptyTable", 'header': "INSPECTION REPORT", 'description': 'Inspection after match drilling operations on Blocks Pilot Drilling (if applicable) (Form 12C)', 'formNum':'Form 12C', 'pageNo': '9' },
  { 'S.no': '5', 'component': "WeldingTable", 'header': "REGISTER", 'subheader': "For welding consumables", 'description': 'Receipt Inspection Stage Register for welding consumables for GMAW process (Wire) (Form 15B1)', 'formNum':'Form 15B1', 'pageNo': '10' },
  { 'S.no': '6', 'component': "WeldingTable", 'header': "REGISTER", 'subheader': "For welding consumables", 'description': 'Receipt Inspection Stage Register for welding consumables for SAW process (Wire) (Form 15B2)', 'formNum':'Form 15B2', 'pageNo': '11' },
  { 'S.no': '7', 'component': "WeldingTable", 'header': "REGISTER", 'subheader': "For welding consumables", 'description': 'Receipt Inspection Stage Register for welding consumables for SAW Process (Flux) (Form 15B3)', 'formNum':'Form 15B3', 'pageNo': '12' },
  { 'S.no': '8', 'component': "WeldingTable", 'header': "REGISTER", 'subheader': "For welding consumables", 'description': 'Receipt Inspection Stage Register for welding consumables for SMAW Process (Form 15B4)', 'formNum':'Form 15B4', 'pageNo': '13' },
  { 'S.no': '9', 'component': "EmptyTable", 'header': "REGISTER", 'subheader': "Welding Consumable control sheet at Shop Floor during production", 'off':'yes','description': 'Register for Welding Consumable Control Sheet at shop Floor during production (Form 15C1)', 'formNum':'Form 15C1', 'pageNo': '14' },
  { 'S.no': '10', 'component': "EmptyTable", 'header': "REGISTER", 'subheader': "Register for Welding Consumable Baking Sheet at Shop Floor (SAW Process Flux)", 'off':'yes', 'description': 'Register for Welding Consumable Baking Sheet at Shop Floor (SAW Process Flux) (Form 15C2-1)', 'formNum':'Form 15C2-1', 'pageNo': '15' },
  { 'S.no': '11', 'component': "EmptyTable", 'header': "REGISTER", 'subheader': "Register for Welding Consumable Baking Sheet at Shop Floor (SMAW Process )", 'off':'yes', 'description': 'Register for Welding Consumable Baking Sheet at Shop Floor (SMAW Process ) (Form 15C2-2)', 'formNum':'Form 15C2-2', 'pageNo': '16' },
  { 'S.no': '12', 'component': "EmptyTable", 'header': "REGISTER", 'subheader': "Register for Welding Consumable Issue at Shop Floor (SAW Process - Wire)", 'off':'yes', 'description': 'Register for Welding Consumable Issue at Shop Floor (SAW Process - Wire) (Form 15C3-1)', 'formNum':'Form 15C3-1', 'pageNo': '17' },
  { 'S.no': '13', 'component': "EmptyTable", 'header': "REGISTER", 'subheader': "Register for Welding Consumable Issue at Shop Floor (SAW Process - Flux)", 'off':'yes', 'description': 'Register for Welding Consumable Issue at Shop Floor (SAW Process - Flux) (Form 15C3-2)', 'formNum':'Form 15C3-2', 'pageNo': '18' },
  { 'S.no': '14', 'component': "EmptyTable", 'header': "REGISTER", 'subheader': "Register for Welding Consumable Issue at Shop Floor (GMAW Process)", 'off':'yes', 'description': 'Register for Welding Consumable Issue at Shop Floor (GMAW Process) (Form 15C3-3)', 'formNum':'Form 15C3-3', 'pageNo': '19' },
  { 'S.no': '15', 'component': "EmptyTable", 'header': "REGISTER", 'subheader': "Register for Welding Consumable Issue at Shop Floor (SMAW Process)", 'off':'yes', 'description': 'Register for Welding Consumable Issue at Shop Floor (SMAW Process) (Form 15C3-4)', 'formNum':'Form 15C3-4', 'pageNo': '20' },
  { 'S.no': '16', 'component': "EmptyTable", 'header': "INSPECTION REPORT", 'description': 'Inspection Control Sheet during Box/ H Assembly / Plate to Plate -FIT-UP.Pre-check Weld Parameters (Form 15D1)', 'formNum':'Form 15D1', 'pageNo': '21' },
  { 'S.no': '17', 'component': "EmptyTable", 'header': "INSPECTION REPORT", 'description': 'Inspection Control Sheet during Box/ H Assembly / Plate to Plate -FIT-UP.Pre-check Tack Weld (Form 15D2)', 'formNum':'Form 15D2', 'pageNo': '22' },
  { 'S.no': '18', 'component': "EmptyTable", 'header': "INSPECTION REPORT", 'description': 'Inspection Control Sheet during Box/ H Assembly / Plate to Plate -FIT-UP.Pre-check- Dimensions (Form 15D3)', 'formNum':'Form 15D3', 'pageNo': '23' },
  { 'S.no': '19', 'component': "EmptyTable", 'header': "REGISTER", 'description': 'Register for welding parameters (Form 15E)', 'pageNo': '24' },
  { 'S.no': '20', 'component': "EmptyTable", 'header': "INSPECTION REPORT", 'description': 'Post welding Inspection Block Weld Visual (Form 15F1)', 'pageNo': '25' },
  { 'S.no': '21', 'component': "EmptyTable", 'header': "INSPECTION REPORT", 'description': 'Post welding Inspection Block and Assembly (Dimensions, Geometry and Bolt holes) (Form 15F2)', 'pageNo': '26' },
  { 'S.no': '22', 'component': "EmptyTable", 'header': "INSPECTION REPORT", 'description': 'Post welding Inspection NDT (Form 15F3)', 'pageNo': '27' },
  { 'S.no': '23', 'component': "EmptyTable", 'header': "INSPECTION REPORT", 'description': 'Mock Test Inspection Stages Clearance Checklist (Form 15G)', 'pageNo': '28' },
]

export const getPageData = (reportId:number, report:string) => {
  let listjson = tableOfContentsJson
  if(report == 'filter-test'){
    listjson = tableOfContentsJson
  }
  if(report == 'material-receipt'){
    listjson = materialReceiptTableOfContentsJson
  }
  if(reportId<listjson.length){
    return listjson[reportId]
  }
  return {}
}

export const getReportDataJson = (reportType:string) => {
  if(reportType == 'filter-test'){
    return {
      tableOfContents: tableOfContentsJson,
    }
  }
  if(reportType == 'material-receipt'){
    return {
      tableOfContents: materialReceiptTableOfContentsJson,
    }
  }
  return {}
}

export const getDefaultFiltersValues = (reportType: any) => {
  if(reportType == "filter-test"){
    return {'filter-test':{
      splitLeft:{
        "title":"CONSORTIUM",
        "line1":"Member-Associated JV-9 consortium",
        "line2":"Package No MAHSR P-4 (V)"
      },
      splitRight: {
        "title":"INSPECTION AND TEST PLAN",
        "line1":"NAME: INSPECTION AND MONITORING OF WELDING",
        "line2":"Page 1 of 9"
      },
      tableOfContents: getReportDataJson(reportType)['tableOfContents']
    }}
  }
  if(reportType == "material-receipt"){
    return {'material-receipt':{
      splitLeft:{
        "title":"CONSORTIUM",
        "line1":"Member-Associated JV-9 consortium",
        "line2":"Package No MAHSR P-4 (V)"
      },
      splitRight: {
        "title":"INSPECTION AND TEST PLAN",
        "line1":"NAME: INSPECTION AND MONITORING OF WELDING",
        "line2":"Page 1 of 9"
      },
      tableOfContents: getReportDataJson(reportType)['tableOfContents']
    }}
  }
  return {}
}


export const getReportData = async (reportType:string, filters:any) => {
  if(reportType == "material"){
    const fetchedSites = await getSites();

    const materialData = await getMaterialReportData()

    const urls: { [key: string]: string | null } = {};
    for (const inspection of materialData?.inspections) {
      for (const item of inspection?.all_document_ids) {
        if (!Object.keys(urls).includes(item)) {
          const url = await fetchFileUrl(item);
          urls[item] = url;
        }
      }
    }

    return {
      'materialReportData': materialData,
      'sites': fetchedSites,
      'fileUrls': urls
    }

  }
  if(reportType == "material-summary"){
    const materialSummaryData = await getMaterialSummaryReportData()
    
    const materialData = await getMaterialReportData()

    return {
      'materialReportData': materialData,
      'materials': materialSummaryData,
    }
  }
  if(reportType == 'history'){
    const fetchedAllFormData:any = await getProjectForms();
    return {
      "allFormData":fetchedAllFormData
    }
  }
  if(reportType == 'systemwide-history'){
    const fetchedAllFormData:any = await getProjectForms();
    return {
      "allFormData":fetchedAllFormData
    }
  }
  if(reportType == 'rawmaterial'){
    const materialSummaryData = await getMaterialSummaryReportData()
    const materialData = await getMaterialReportData()

    return {
      'materialReportData': materialData,
      'materials': materialSummaryData,
    }
  }
  if(reportType == 'content'){
    const fetchedAllFormData:any = await getProjectForms();
    return {
      "allFormData":fetchedAllFormData
    }
  }
  if(reportType == 'filter-test'){
    if(typeof(filters) == 'object' && Object.keys(filters).includes('filter-test')){
      return filters['filter-test'];
    }

    return {
      splitLeft:{
        "title":"",
        "line1":"",
        "line2":""
      },
      splitRight: {
        "title":"",
        "line1":"",
        "line2":""
      },
      tableOfContents: []
    };
  }
  if(reportType == 'material-receipt'){
    if(typeof(filters) == 'object' && Object.keys(filters).includes('material-receipt')){
      return filters['material-receipt'];
    }

    return {
      splitLeft:{
        "title":"",
        "line1":"",
        "line2":""
      },
      splitRight: {
        "title":"",
        "line1":"",
        "line2":""
      },
      tableOfContents: []
    };
  }
  if(reportType == "inspection-report-steel"){

    return {
        "pages":[
          {
            "type":"marginPage",
            "sections":[{
              "type": "textSection",
              "title": "Inspection Report"
            },
            {
              "type": "textSection",
              "title": "Inspection Report"
            }]
          }
        ]
    }
  }
  return {}
}



export const tableHeaders = (table: string) => {
  if(table == 'weldingtable'){
    const headers = [
      { label: 'Sr', width: '3%' },
      { label: 'Fabrication shop', width: '10%' },
      { label: 'PO Ref # / Date', width: '8%' },
      { label: 'Supplier / Dealer', width: '8%' },
      { label: 'Manufacturer', width: '8%' },
      {
        label: 'Delivery details',
        width: '25%',
        subHeaders: [
          { label: 'Challan #', width: '45%' },
          { label: 'Date', width: '25%' },
          { label: 'Qty', width: '15%' },
          { label: 'UOM', width: '15%', borderRight: 0 },
        ],
      },
      {
        label: 'Welding Consumable',
        width: '38%',
        borderRight: 0,
        subHeaders: [
          { label: 'Brand Name', width: '20%' },
          { label: 'Filler wire Diameter', width: '20%' },
          { label: 'Batch #', width: '20%' },
          { label: 'Certificate # & Compliance (Attach Photo)', width: '20%' },
          { label: 'Remarks (Accepted/ Rejected)', width: '20%', borderRight: 0 },
        ],
      },
    ]

    const tableRows = Array(8).fill(null).map((_, index) => ({
      key: index,
      cells: Array(tableHeaders.length).fill(''),
    }));


    return {
      "headers": headers,
      "rows": tableRows,
    }
  }
  if(table == 'studsferrule'){
    const headers = [
      { label: 'Sr#', width: '3%' },
      {
        label: 'Receipt',
        width: '43%',
        subHeaders: [
          { label: 'Item Description', width: '15%' },
          { label: 'Manufacturer', width: '15%' },
          { label: 'PO#/ Date', width: '15%' },
          { label: 'Batch#, Certificate#, Date', width: '15%' },
          { label: 'Delivery Challan#, Date, Quantity', width: '15%' },
          { label: 'Inspection Result (accepted/ Rejected)', width: '15%' },
          { label: 'Sign', width: '10%', borderRight: 0 },
        ],
      },
      {
        label: 'Sampling',
        width: '25%',
        borderRight: 0,
        subHeaders: [
          { label: 'Sample Quantity', width: '20%' },
          { label: 'Delivery Challan#, Date, Quantity', width: '20%' },
          { label: 'Batch #', width: '20%' },
          { label: 'Lab Name', width: '20%' },
          { label: 'Sign', width: '20%', borderRight: 0 },
        ],
      },
      {
        label: 'Result',
        width: '21%',
        subHeaders: [
          { label: 'Lab Report#, Date', width: '33%' },
          { label: 'Result OK/NOT OK', width: '33%' },
          { label: 'Sign', width: '34%', borderRight: 0 },
        ],
      },
      { label: 'Remarks', width: '8%' }
    ]

    const tableRows = Array(12).fill(null).map((_, index) => ({
      key: index,
      cells: Array(tableHeaders.length).fill(''),
    }));


    return {
      "headers": headers,
      "rows": tableRows,
    }
  }
  if(table == 'studsferrule1'){
    const headers = [
      { label: 'Sr#', width: '3%' },
      {
        label: 'Receipt',
        width: '43%',
        subHeaders: [
          { label: 'Item Description', width: '15%' },
          { label: 'Manufacturer', width: '12%' },
          { label: 'PO#/ Date', width: '12%' },
          { label: 'Delivery Challan#, Date, Quantity', width: '12%' },
          { label: 'MTC#, Heat #', width: '12%' },
          { label: 'Ferrule ID/ Certificate', width: '12%' },
          { label: 'Inspection Result (accepted/ Rejected)', width: '12%' },
          { label: 'Sign', width: '12%', borderRight: 0 },
        ],
      },
      {
        label: 'Sampling',
        width: '25%',
        borderRight: 0,
        subHeaders: [
          { label: 'Sample Quantity', width: '25%' },
          { label: 'Delivery Challan#, Date', width: '25%' },
          { label: 'Lab Name', width: '25%' },
          { label: 'Sign', width: '25%', borderRight: 0 },
        ],
      },
      {
        label: 'Result',
        width: '21%',
        subHeaders: [
          { label: 'Lab Report#, Date', width: '33%' },
          { label: 'Result OK/NOT OK', width: '33%' },
          { label: 'Sign', width: '34%', borderRight: 0 },
        ],
      },
      { label: 'Remarks', width: '8%' }
    ]

    const tableRows = Array(12).fill(null).map((_, index) => ({
      key: index,
      cells: Array(tableHeaders.length).fill(''),
    }));


    return {
      "headers": headers,
      "rows": tableRows,
    }
  }
  if(table == 'studsferrule2'){
    const headers = [
      { label: 'Sr#', width: '3%' },
      {
        label: 'Receipt',
        width: '43%',
        subHeaders: [
          { label: 'Item Description', width: '15%' },
          { label: 'Manufacturer', width: '15%' },
          { label: 'PO#/ Date', width: '15%' },
          { label: 'Delivery Challan#, Date, Quantity', width: '15%' },
          { label: 'MTC#, Heat #, (*)', width: '15%' },
          { label: 'Inspection Result (accepted/ Rejected)', width: '15%' },
          { label: 'Sign', width: '10%', borderRight: 0 },
        ],
      },
      {
        label: 'Sampling',
        width: '25%',
        borderRight: 0,
        subHeaders: [
          { label: 'Sample Quantity', width: '25%' },
          { label: 'Delivery Challan#, Date', width: '25%' },
          // { label: 'Batch #', width: '20%' },
          { label: 'Lab Name', width: '25%' },
          { label: 'Sign', width: '25%', borderRight: 0 },
        ],
      },
      {
        label: 'Result',
        width: '21%',
        subHeaders: [
          { label: 'Lab Report#, Date', width: '33%' },
          { label: 'Result OK/NOT OK', width: '33%' },
          { label: 'Sign', width: '34%', borderRight: 0 },
        ],
      },
      { label: 'Remarks', width: '8%' }
    ]

    const tableRows = Array(12).fill(null).map((_, index) => ({
      key: index,
      cells: Array(tableHeaders.length).fill(''),
    }));


    return {
      "headers": headers,
      "rows": tableRows,
    }
  }
  if(table == 'studsferrule3'){
    const headers = [
      { label: 'Sr#', width: '3%' },
      {
        label: 'Receipt',
        width: '43%',
        subHeaders: [
          { label: 'Item Description', width: '15%' },
          { label: 'Manufacturer', width: '15%' },
          { label: 'PO#/ Date', width: '15%' },
          { label: 'Delivery Challan#, Date, Quantity', width: '15%' },
          { label: 'MTC#, Heat #, (*)', width: '15%' },
          { label: 'Inspection Result (accepted/ Rejected)', width: '15%' },
          { label: 'Sign', width: '10%', borderRight: 0 },
        ],
      },
      {
        label: 'Sampling',
        width: '25%',
        borderRight: 0,
        subHeaders: [
          { label: 'Sample Quantity', width: '25%' },
          { label: 'Delivery Challan#, Date', width: '25%' },
          // { label: 'Batch #', width: '20%' },
          { label: 'Lab Name', width: '25%' },
          { label: 'Sign', width: '25%', borderRight: 0 },
        ],
      },
      {
        label: 'Result',
        width: '21%',
        subHeaders: [
          { label: 'Lab Report#, Date', width: '33%' },
          { label: 'Result OK/NOT OK', width: '33%' },
          { label: 'Sign', width: '34%', borderRight: 0 },
        ],
      },
      { label: 'Remarks', width: '8%' }
    ]

    const tableRows = Array(12).fill(null).map((_, index) => ({
      key: index,
      cells: Array(tableHeaders.length).fill(''),
    }));


    return {
      "headers": headers,
      "rows": tableRows,
    }
  }
  const headers = [
    { label: 'Sr', width: '3%' },
    { label: 'Fabrication shop', width: '10%' },
    { label: 'PO Ref # / Date', width: '8%' },
    { label: 'Supplier / Dealer', width: '8%' },
    { label: 'Manufacturer', width: '8%' },
    {
      label: 'Delivery details',
      width: '25%',
      subHeaders: [
        { label: 'Challan #', width: '45%' },
        { label: 'Date', width: '25%' },
        { label: 'Qty', width: '15%' },
        { label: 'UOM', width: '15%', borderRight: 0 },
      ],
    },
    {
      label: 'Welding Consumable',
      width: '38%',
      borderRight: 0,
      subHeaders: [
        { label: 'Brand Name', width: '20%' },
        { label: 'Filler wire Diameter', width: '20%' },
        { label: 'Batch #', width: '20%' },
        { label: 'Certificate # & Compliance (Attach Photo)', width: '20%' },
        { label: 'Remarks (Accepted/ Rejected)', width: '20%', borderRight: 0 },
      ],
    },
  ]

  const tableRows = Array(8).fill(null).map((_, index) => ({
    key: index,
    cells: Array(tableHeaders.length).fill(''),
  }));


  return {
    "headers": headers,
    "rows": tableRows,
  }
}